import React, { useState, useEffect, useMemo } from "react";
import CustomDialog from "../../UniversalComponents/CustomDialog";
import AddTask from "../AddTask";
import AddNotes from "../notes";
import CustomerDocument from "../Documents/CustomerDocument";
import CustomRender from "../customer-other-details/CustomRender";
import InternalNavigation from "../../UniversalComponents/InternalNavigation";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { useSidebar } from "../../SidebarContext";
import { mySpacePersonList, mySpaceTableBulkUpdateListValue } from "../../../utils/api/mySpaceApi";
import { getCompanyId } from "../../../utils/utilityFunctions/localServices";
import { useFetchCustomerTableDataNewMutation } from "../../../utils/customer/customerTable";
import { pushAlert } from "../../../utils/alertSlice";
import { getUserTokeData } from "../../../utils/userSlice";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import { getSentenceCase } from "../../../utils/utilityFunctions/stringUtility";

import {
  addUpdateFieldValue,
  fetchColumnDropdownOptions,
  fetchHeaders,
  fetchHeaderValues,
} from "../../../utils/api/customModuleApi";

function RedirectModulePreview({
  rowData = {},
  onClose = () => null,
  isDialog = false,
  isCompanyLevel,
  propTemplateId,
  customerId,
}) {
  const location = useLocation();
  const dispatch = useDispatch();

  const { templateId = null } = useParams();

  const [customerIdForCompanyLevel, setCustomerIdForCompanyLevel] = useState(null);
  const [activeSubmodule, setActiveSubmodule] = useState({});

  const [containerId, setContainerId] = useState(propTemplateId || templateId || null);

  const [multiData, setMultiData] = useState({});
  // const [showShareFileModal, setShowShareFileModal] = useState(false);
  const [headerConfigData, setHeaderConfigData] = useState([]);
  const [headerConfigDataRaw, setHeaderConfigDataRaw] = useState({});

  const [mySpaceBody, setMySpaceBodyData] = useState([]);
  const [mySpaceBodyRaw, setMySpaceBodyDataRaw] = useState({});
  const [dropdownOptionsData, setDropdownOptionsData] = useState([]);

  const [headerSingleFormat, setHeaderSingleFormat] = useState({});
  const [headerBodyFormat, setHeaderBodyFormat] = useState({});
  const [subModulesItems, setSubModulesItems] = useState([]);

  const [isApiLoading, setIsApiLoading] = useState(false);

  //For setting data in Header
  const sidebarContext = useSidebar();
  const setheaderProps = sidebarContext?.setheaderProps;

  console.log("PreviewWrapper recordData: Preview:", rowData, propTemplateId);

  // Helper: safe JSON parse
  const safeParse = (s) => {
    try {
      if (typeof s !== "string") return null;
      return JSON.parse(s);
    } catch {
      return null;
    }
  };

  const normalize = (v) => {
    if (v === null || v === undefined) return "";
    return String(v).trim().toLowerCase();
  };

  // This extracts comparable strings from many shapes (primitives, wrapper objects, arrays, choice objects, people)
  const extractStringsFromEntry = (entry) => {
    if (entry == null) return [];

    // primitive
    if (["string", "number", "boolean"].includes(typeof entry)) {
      return [normalize(entry)];
    }

    // If entry is a JSON string (whole-entry string), try parse
    if (typeof entry === "string") {
      const parsedTop = safeParse(entry);
      if (parsedTop && typeof parsedTop === "object") {
        return extractStringsFromEntry(parsedTop);
      }
      return [normalize(entry)];
    }

    // If entry is an array: flatten inner items
    if (Array.isArray(entry)) {
      const res = [];
      for (const inner of entry) {
        if (inner == null) continue;
        // If inner is primitive
        if (["string", "number", "boolean"].includes(typeof inner)) {
          res.push(normalize(inner));
          continue;
        }
        // If inner has email (people)
        if (inner.email) {
          res.push(normalize(inner.email));
          continue;
        }
        // inner has value field (choice objects)
        if (inner.value !== undefined) {
          // case: inner.value is primitive
          if (["string", "number", "boolean"].includes(typeof inner.value)) {
            res.push(normalize(inner.value));
            continue;
          }
          // case: inner.value is object — try nested keys
          if (typeof inner.value === "object" && inner.value !== null) {
            // try inner.value.value first, then textForUrl, then url, then name, then email
            const iv = inner.value;
            if (iv.value !== undefined && ["string", "number", "boolean"].includes(typeof iv.value)) {
              res.push(normalize(iv.value));
              continue;
            }
            if (iv.textForUrl) {
              res.push(normalize(iv.textForUrl));
              continue;
            }
            if (iv.url) {
              res.push(normalize(iv.url));
              continue;
            }
            if (iv.name) {
              res.push(normalize(iv.name));
              continue;
            }
            if (iv.email) {
              res.push(normalize(iv.email));
              continue;
            }
          }
          // case: inner.value is stringified JSON
          if (typeof inner.value === "string") {
            const parsed = safeParse(inner.value);
            if (parsed && typeof parsed === "object") {
              const pick = parsed.textForUrl ?? parsed.url ?? parsed.value ?? parsed.name ?? parsed.email;
              if (pick) {
                res.push(normalize(pick));
                continue;
              }
            }
            // fallback to raw string
            res.push(normalize(inner.value));
            continue;
          }
        }

        // fallback: try common fields on inner
        if (inner.textForUrl) {
          res.push(normalize(inner.textForUrl));
          continue;
        }
        if (inner.url) {
          res.push(normalize(inner.url));
          continue;
        }
        if (inner.name) {
          res.push(normalize(inner.name));
          continue;
        }
        if (inner.value !== undefined && (typeof inner.value === "string" || typeof inner.value === "number")) {
          res.push(normalize(inner.value));
          continue;
        }

        // last resort: stringify inner (but normalized)
        try {
          res.push(normalize(JSON.stringify(inner)));
        } catch {
          // ignore
        }
      }
      return res.filter(Boolean);
    }

    // entry is an object (not array)
    if (typeof entry === "object") {
      // If person-like
      if (entry.email) return [normalize(entry.email)];

      // If entry looks like direct choice object {id, value, color}
      if (
        entry.value !== undefined &&
        (typeof entry.value === "string" || typeof entry.value === "number" || typeof entry.value === "boolean")
      ) {
        return [normalize(entry.value)];
      }

      // If entry.value is an array (wrapper that contains choices)
      if (Array.isArray(entry.value)) {
        return extractStringsFromEntry(entry.value);
      }

      // If entry.value is a string that might be JSON (hyperlink case)
      if (typeof entry.value === "string") {
        const parsedInner = safeParse(entry.value);
        if (parsedInner && typeof parsedInner === "object") {
          const pick =
            parsedInner.textForUrl ?? parsedInner.url ?? parsedInner.value ?? parsedInner.name ?? parsedInner.email;
          if (pick) return [normalize(pick)];
        }
        return [normalize(entry.value)];
      }

      // If entry.value is an object (wrapper style: { value: { value: "..." } })
      if (entry.value && typeof entry.value === "object") {
        const inner = entry.value;
        if (inner.value !== undefined && (typeof inner.value === "string" || typeof inner.value === "number")) {
          return [normalize(inner.value)];
        }
        if (inner.textForUrl) return [normalize(inner.textForUrl)];
        if (inner.url) return [normalize(inner.url)];
        if (inner.name) return [normalize(inner.name)];
        if (inner.email) return [normalize(inner.email)];
        // try one level deeper if inner.value is object
        if (inner.value && typeof inner.value === "object") {
          const deeper = inner.value;
          if (deeper.value !== undefined) return [normalize(deeper.value)];
          if (deeper.textForUrl) return [normalize(deeper.textForUrl)];
          if (deeper.url) return [normalize(deeper.url)];
        }
      }

      // fallback common fields directly on entry
      if (entry.textForUrl) return [normalize(entry.textForUrl)];
      if (entry.url) return [normalize(entry.url)];
      if (entry.name) return [normalize(entry.name)];

      // last resort: try to stringify a small subset (prefer primitive props)
      for (const k of Object.keys(entry)) {
        const v = entry[k];
        if (["string", "number", "boolean"].includes(typeof v)) {
          return [normalize(v)];
        }
      }

      // ultimate fallback: stringify whole object
      try {
        return [normalize(JSON.stringify(entry))];
      } catch {
        return [];
      }
    }

    return [];
  };

  // To display label from template id

  function getLabelByTemplateId(items, propTemplateId) {
    if (!propTemplateId) return null;

    const match = items.find((it) => {
      if (!it?.path || typeof it.path !== "string") return false;
      if (!it.path.startsWith("/company-module/")) return false;

      // grab the last segment of the path (handles optional trailing slash)
      const lastSeg = it.path.replace(/\/+$/, "").split("/").pop();
      return lastSeg === propTemplateId;
    });

    return match?.label ?? null;
  }

  const menuList = JSON.parse(localStorage.getItem("fullMenuList") || "[]");
  const label = getLabelByTemplateId(menuList, propTemplateId);

  useEffect(() => {
    if (!isCompanyLevel) return;
    setheaderProps({ name: getSentenceCase(label) });

    return () => {
      setheaderProps(null);
    };
  }, [setheaderProps, propTemplateId, label]);

  useEffect(() => {
    if (!isCompanyLevel) {
      setCustomerIdForCompanyLevel(rowData?.core_id);
    }
  }, [rowData?.core_id]);

  const [{ data: customerTableALL, isLoading: customerListLoading, isFetching: customerListFetching }] =
    useFetchCustomerTableDataNewMutation();

  const handleBulkFieldUpdateList = async ({ tableId, fieldId, rowsIds, value }) => {
    try {
      const response = await mySpaceTableBulkUpdateListValue({
        params: { tableId: tableId },
        body: {
          fieldId: fieldId,
          rowIds: rowsIds,
          data: { value },
        },
      });

      if (response?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "success",
          })
        );
        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleSingleUpdateField = async ({ fieldValue, column_info, row_id }) => {
    try {
      const columnInfo = headerConfigData?.find((header) => header?.value === column_info?.key);

      // "data" consist directly the main value.
      let data = fieldValue;

      if (columnInfo?.meta?.absoluteType === "hyperlink") {
        data = { textForUrl: fieldValue?.textForUrl, url: fieldValue?.url };
      }

      if (columnInfo?.type === "dropdown") {
        data = fieldValue?.id;
      }

      if (columnInfo?.type === "multiselect") {
        data = fieldValue?.map((data) => data?.id);
      }

      const checkBoxSelectedIds = Object.keys(multiData).filter((info) => {
        return !isNaN(Number(info));
      });

      if (checkBoxSelectedIds?.length > 0) {
        await handleBulkFieldUpdateList({
          tableId: containerId,
          fieldId: columnInfo?.id,
          rowsIds: checkBoxSelectedIds,
          value: data,
        });
        return;
      }

      let body = {
        // row_id: row_id,
        core_id: rowData?.core_id || null,
        field_id: columnInfo?.id,
        row_id: row_id,
        value: data,
      };

      const response = await addUpdateFieldValue({ body, query: { key: "u2_core", template_id: containerId } });

      if (response?.success || response?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "success",
          })
        );

        await fetchMySpaceHeaderConfig(containerId);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message,
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  function convertFormatForSingleHeader(apiResponse) {
    if (!apiResponse?.data?.length) return [];

    // define which types to skip
    // const skipTypes = ["task_template", "note_template"];
    const skipTypes = [];

    return apiResponse.data.flatMap((section) => {
      const sectionName = section.title || "";
      const fields = section.fields || [];

      return fields
        .filter((field) => !skipTypes.includes(field.type)) // skip unwanted types
        .map((field) => {
          const { id, value, label, type, meta, is_editable, is_visible } = field;
          const absoluteType = meta?.absoluteType || type || "text";

          const normalizeNumberFormat = (nf) =>
            nf
              ? {
                  symbol: nf.symbol || false,
                  separators: !!nf.separators,
                  decimalPlaces: typeof nf.decimalPlaces === "number" ? nf.decimalPlaces : null,
                  negativeFormat: nf.negativeFormat || "minus",
                  selectedOption:
                    meta?.textFormat?.textSelectedOption ||
                    absoluteType?.charAt(0).toUpperCase() + absoluteType?.slice(1),
                }
              : null;

          const mappedMeta =
            meta && Object.keys(meta).length
              ? {
                  textFormat: meta.textFormat || {},
                  numberFormat: normalizeNumberFormat(meta.numberFormat),
                  dateTimeFormat: meta.dateTimeFormat || {},
                }
              : null;

          let finalType = type;
          if (absoluteType === "person" && !type) {
            finalType = value?.includes("multi") || label?.toLowerCase().includes("multi") ? "multi_person" : "person";
          }

          return {
            key: value || id,
            field_id: id,
            label,
            statuslabel: "0",
            value: value || "",
            type: finalType || "text",
            meta: mappedMeta,
            visibility: true,
            is_visible: is_visible || true,
            sectionName,
          };
        });
    });
  }

  const handleFetchDropdownOptions = async ({ fieldName }) => {
    try {
      const response = await fetchColumnDropdownOptions({ query: { field_name: fieldName } });
      if (response?.success || response?.status) {
        setDropdownOptionsData(
          response?.data?.map((option) => ({ id: option?.id, value: option?.label, color_code: option?.color }))
        );
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  function convertToVisibilityMap(fields) {
    const result = {};
    for (const field of fields) {
      if (field.is_visible === true) {
        result[field.value] = true;
      }
    }
    return result;
  }

  // FETCH MY SPACE TABLE HEADERS
  const fetchMySpaceHeaderConfig = async (containerId) => {
    try {
      setIsApiLoading(true);
      const response = await fetchHeaders({
        // query: { template_id: containerId, ...(isCompanyLevel && { is_company_level: true }) },
        query: { template_id: containerId },
      });
      if (response?.success || response?.status) {
        setHeaderConfigDataRaw(response);
        let extractOnlyColumns = [];
        response?.data?.forEach((columnInfo) => {
          extractOnlyColumns = [
            ...extractOnlyColumns,
            ...(columnInfo?.fields?.map((columnData) => ({ ...columnData, sectionName: columnInfo?.title })) || []),
          ];
        });

        const formatted = convertFormatForSingleHeader(response);
        setHeaderSingleFormat(formatted);
        setSubModulesItems(response?.items || []);

        // -------------

        setHeaderConfigData(extractOnlyColumns);
        // const breadcrumpList = response?.path?.map((data) => {
        //   // Only root folder will be considered as container. so is Null
        //   return {
        //     label: data?.folderName,
        //     id: data?.folderId,
        //     isContainer: data?.folderId ? true : false,
        //   };
        // });
        // setBreadcrumpList(breadcrumpList || [{ label: "My Space", id: null, isContainer: true }]);
        // Defining visibility of columns based on response and previous state.
        // handleManageDrawerData(extractOnlyColumns);
        await fetchMySpaceTableBodyData(containerId, extractOnlyColumns, response?.only_company_level);
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  function convertCustomerDataFormat(apiResponse) {
    if (!apiResponse?.data?.length) return [];

    return apiResponse.data.map((item) => {
      const result = {};
      const flatData = item.data || {};

      for (const [key, valObj] of Object.entries(flatData)) {
        let value = valObj?.value ?? null;

        // if value is array or object -> don't stringify
        if (Array.isArray(value) || (value && typeof value === "object")) {
          result[key] = { value };
        } else if (typeof value === "string" && (value.trim().startsWith("{") || value.trim().startsWith("["))) {
          // attempt to parse JSON-like strings
          try {
            result[key] = { value: JSON.parse(value) };
          } catch {
            result[key] = { value };
          }
        } else {
          result[key] = { value };
        }
      }

      // keep structural identifiers
      result.row_id = item.row_id || null;
      result.core_id = item.core_id || null;
      result.folder_id = item.folder_id || null;

      return result;
    });
  }

  const fetchMySpaceTableBodyData = async (tableId, headerData, only_company_level) => {
    try {
      const response = await fetchHeaderValues({
        query: {
          template_id: tableId,
          ...{ core_id: rowData?.core_id || null },
          ...(rowData?.id && { row_id: rowData?.id }),
        },
      });

      if (response?.success || response?.status) {
        // Factory for a fresh empty-entry based on headers
        // const makeEmpty = () => createEmptyEntry(headerData);
        // console.log("harsh vv", makeEmpty());

        // Pull out and flatten each row’s entire data object
        const existingEntries = response.data.map((item) => ({
          ...item.data,
          id: item?.row_id,
          folder_id: item?.folder_id || null,
          core_id: item?.core_id || null,
        }));

        const formatted = convertCustomerDataFormat(response);
        setHeaderBodyFormat(formatted);

        // setMySpaceBodyDataRaw({ success: true, data: existingEntries });
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response.data?.message || "Something Went Wrong.",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  const handleSingleAddRecord = async () => {
    // Finding column type
    let rowData = [];
    for (let columnInfo of headerConfigData) {
      let columnDropdownOptions = [];
      let columnMetaType = null;

      if (columnInfo?.label === "Task") {
        continue;
      } else if (columnInfo?.label === "Notes") {
        continue;
      }

      // Get options for dropdown like inputs
      if (columnInfo?.type === "dropdown" || columnInfo?.type === "multiselect") {
        // Using self invocation to get options in async

        const response = await fetchColumnDropdownOptions({ query: { field_name: columnInfo?.value } });
        if (!response?.success && !response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }
        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.id,
            label: data?.label,
            color_code: data?.color,
          };
        });
      } else if (columnInfo?.type === "person" || columnInfo?.type === "multi_person") {
        const response = await mySpacePersonList({ params: { companyId: getCompanyId() } });

        if (!response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.message,
              type: "danger",
            })
          );
          return;
        }

        columnDropdownOptions = response?.data?.map((data) => {
          return {
            value: data?.uuid,
            label: data?.name,
            subLabel: data?.email,
            id: data?.id,
          };
        });
      } else if (columnInfo?.type === "text") {
        // if (columnInfo?.meta?.textFormat?.textSelectedOption === "Hyperlink") {
        columnMetaType = columnInfo?.meta?.textFormat?.textSelectedOption;
        // }
      } else if (columnInfo?.type === "date") {
        if (columnInfo?.meta?.absoluteType === "date") {
          columnMetaType = "Date";
        } else {
          columnMetaType = "DateTime";
        }
      }

      if (mySpaceBodyRaw?.data?.[0]) {
        rowData.push({
          name: columnInfo?.label || null,
          value: mySpaceBodyRaw?.data?.[0]?.[columnInfo?.value]?.value || null,
          type: columnInfo?.type || null,
          options: columnDropdownOptions || null,
          id: columnInfo?.id || null,
          columnMetaType: columnMetaType || null,
          is_editable: columnInfo?.is_editable,
          sectionName: columnInfo?.sectionName,
          row_id: mySpaceBodyRaw?.data?.[0]?.id,
        });
      } else {
        rowData.push({
          name: columnInfo?.label || null,
          value: null, // Initial value defined for text and value and updatingit later for dropdown/multiselect
          type: columnInfo?.type || null,
          options: columnDropdownOptions || null,
          id: columnInfo?.id || null,
          columnMetaType: columnMetaType || null,
          is_editable: columnInfo?.is_editable,
          sectionName: columnInfo?.sectionName,
          row_id: null,
        });
      }
    }
  };

  // Notes Modal -----------------------------------------------------------------

  // DOCUMENT UPLOAD MODAL -------------------------------------------------------

  // DOCUMENT UPLOAD MODAL -------------------------------------------------------

  // When click on file, the headerAPI will be called and update the table content.
  useEffect(() => {
    if (containerId || rowData?.id) {
      fetchMySpaceHeaderConfig(containerId);
      console.log("harsh useEffect called");
    }
  }, [containerId, rowData?.id]);

  useEffect(() => {
    setContainerId(propTemplateId || templateId);
  }, [propTemplateId, templateId]);

  useEffect(() => {
    if (isApiLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isApiLoading]);

  useEffect(() => {
    if (customerTableALL) {
      setMultiData({});
    }
  }, [customerTableALL]);

  useEffect(() => {
    if (location.key) {
      dispatch(getUserTokeData());
    }
  }, [location.key]);

  useEffect(() => {
    if (headerConfigDataRaw?.is_multi_records === false && mySpaceBodyRaw?.success) {
      handleSingleAddRecord();
    }
  }, [headerConfigDataRaw, mySpaceBodyRaw]);

  const componentList = {
    TaskModule: AddTask,
    CustomerNotes: AddNotes,
    CustomerDocument: CustomerDocument,
    CustomModule: <></>,
  };

  const PageContent = componentList[activeSubmodule?.component] || (() => <div>No Component Found</div>);
  return (
    <CustomDialog fullScreen maxWidth="lg" fullWidth open={true} onClose={onClose} noDialog={!isDialog}>
      <div className=" flex flex-col h-full gap-4">
        {/* navigation */}
        <div className="flex items-center justify-between">
          <InternalNavigation
            items={subModulesItems}
            subTabValue={activeSubmodule.value ?? "dashboard"}
            disableRouting
            isIcons
            onSelect={(val) => setActiveSubmodule(val)}
          />
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-xl">
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* divider */}
        <div className="border-b border-[rgba(19, 19, 19, 0.08)]"></div>
        {activeSubmodule?.value === "dashboard" ? (
          <div>
            <CustomRender
              headerData={headerSingleFormat}
              headerBodyData={headerBodyFormat}
              onSubmit={handleSingleUpdateField}
              fetchDropdownApi={handleFetchDropdownOptions}
              dropdownOptions={dropdownOptionsData}
              isCustomModule={true}
            />
          </div>
        ) : (
          <div className="grow min-h-0 ">
            <PageContent
              row_id={rowData?.id}
              core_id={rowData?.core_id}
              propTemplateId={propTemplateId}
              moduleTaskId={activeSubmodule?.value}
              disableAddMode
            />
          </div>
        )}
      </div>
    </CustomDialog>
  );
}

export default RedirectModulePreview;
